/**
 * Erfuellt / nicht erfuellt als Symbol (F-39) - statt der Textzeichen
 * ✓ und ✗, die nicht jede Schrift enthaelt. Fuer Screenreader steht die
 * Bedeutung als Text da.
 */
import { Check, X } from 'lucide-react';

import { cn } from '@/lib/utils/cn';

export function Haken({ ja, className, label }: {
  ja: boolean;
  className?: string;
  /** Vorgelesener Text, Standard "erfüllt" bzw. "nicht erfüllt". */
  label?: string;
}) {
  const Symbol = ja ? Check : X;
  return (
    <span className={cn('inline-flex shrink-0 items-center', ja ? 'text-ok' : 'text-ink-faint', className)}>
      <Symbol aria-hidden="true" className="size-3.5" />
      <span className="sr-only">{label ?? (ja ? 'erfüllt' : 'nicht erfüllt')}</span>
    </span>
  );
}
